import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  loaderSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);

  toggleLoader(toggle: boolean) {
    this.loaderSubject.next(toggle);
  }
}
